/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { staffSchema } from "./staffSchema.ts";

export const orgOrganizationStaffRetrievePathIdSchema = z.uuid();

export const orgOrganizationStaffRetrievePathOrganizationIdSchema = z.uuid();

export const orgOrganizationStaffRetrieveStatus200Schema = staffSchema;

export const orgOrganizationStaffRetrieveResponseSchema = orgOrganizationStaffRetrieveStatus200Schema;
